import NumberStr from './number-str';
import static_menu_list from '../_store/nav_list_dic';
import Const from '../_store/const';
function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    // if (isSymbol(value)) {
    //     return NAN;
    // }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}
function now(){
    return new Date();
}
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var Util = {
    tmpUUId : null,
    generateRandomAlphaNum(len = 8) {
        var rdmString = "";
        //toSting接受的参数表示进制，默认为10进制。36进制为0-9 a-z
        for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2));
        return rdmString.substr(0, len);
    },
    getTmpUUID(){
        if(this.tmpUUId){
            return this.tmpUUId;
        }else{
            this.tmpUUId = this.generateRandomAlphaNum();
            return this.tmpUUId;
        }
    },
    // 将http开头的协议换成相对协议
    transferToRelativeProtocol(baseUrl) {
        return baseUrl.replace(/^http:\/\//, '//');
    },
    initCurTabInfo(optUrl){
        let _url = optUrl || window.location.href;
        let _arr = _url.split('/ch/');
        let cur_id = parseInt(_arr[1]) || Const.FIRST_CHANNEL_ID;
        let cur_index = Const.FIRST_CHANNEL_INDEX;
        static_menu_list.forEach(function(o, index){
            if(o.channel_id === cur_id){
                cur_index = index;
            }
        });
        var res = {
            cur_index : cur_index,
            cur_channel_id : cur_id
        };
        return res;
    },
    initSSReadState() {
        var ids = [];
        $("[data-state]").each(function () {
            var id = $(this).data("state");
            ids.push(id);
        });
        //TODO: 获取统计接口,回填
        $.ajax({
            url: "//v2.sohu.com/public-api/articles/pv?articleIds=" + ids.join(",") + "&callback=?",
            dataType: 'jsonp',
        }).then((response) => {
            if (response) {
                for (var n in response) {
                    $("[data-state='" + n + "']").text(new NumberStr(response[n]).format());
                }
            }
        }, (err) => {
            console.log(err);
        });
    },
    mixObjByTemplate(tplObj, item){
        var objToStrFunc = Object.prototype.toString;
        var ObjStr = '[object Object]';
        var res = {};
        if ((tplObj && objToStrFunc.call(tplObj) === ObjStr) && (item && objToStrFunc.call(item) === ObjStr)) {
            for(var i in tplObj){
                if(tplObj.hasOwnProperty(i)){
                    if(typeof item[i] === 'number'){
                        res[i] = item[i];
                    }else {
                        res[i] = item[i] || tplObj[i];
                    }
                }
            }
        }
        return res;
    },
    isEmpty: function (obj) {
        if (obj.replace(/(^\s*)|(\s*$)/g, '').length <= 0) {//null
            return true;
        } else {// not null
            return false;
        }
    },
    isSupportSticky: function() {//检测是否支持sticky
        var prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
        var stickyText = '';
        for (var i = 0; i < prefixTestList.length; i++ ) {
            stickyText += 'position:' + prefixTestList[i] + 'sticky;';
        }
        // 创建一个dom来检查
        var div = document.createElement('div');
        div.style.cssText = stickyText;
        document.body.appendChild(div);
        var isSupport = /sticky/i.test(window.getComputedStyle(div).position);
        document.body.removeChild(div);
        div = null;
        return isSupport;
    },
    //压缩图片
    mini_picUrl: function(url,size){
        size = size||375;
        return url.replace('29e5534ea20a8.cdn.sohucs.com','29e5534ea20a8.cdn.sohucs.com/q_mini,c_zoom,w_'+size).replace('//p.mp.sohu.com','//p.mp.sohu.com/q_mini,c_zoom,w_'+size)
    },
    checkMobile: function (obj) {
        if (this.isEmpty(obj) || (!/^1([3-9][0-9]{9})$/.test(obj))) {//格式不正确
            return false;
        } else {// 格式正确
            return true;
        }
    },
    checkEmail: function(obj) {
        if (this.isEmpty(obj) || (!/^([\w]+)(.[\w]+)*@([\w-]+\.){1,5}([A-Za-z]){2,4}$/.test(obj))) {//格式不正确
            return false;
        } else {// 格式正确
            return true;
        }
    },
    /**
     * [addQueryArgs 给url添加参数]
     * @param {[string]} url      [需添加参数的url]
     * @param {[object]} paramObj [需添加的参数,hash键值对形式]
     */
     addQueryArgs: function (url, paramObj) {
        var result;
        var key, value;
        if(!url){//url 为空不做处理。
            
            return '';
        }
        for (key in paramObj) {
            value = paramObj[key];
            result = new RegExp("(" + key + "=)[^&]+", "i");
            if (url.match(result)) {
                url = url.replace(result, "$1" + value);
            } else {
                url += (url.indexOf('?') === -1) ?
                ('?' + key + '=' + value) : ('&' + key + '=' + value);
            }
        }

        return url;
    },
    isOnScreen: function (_dom) {
        var dom = _dom;
        if (typeof _dom === 'string') {
            dom = document.querySelector(_dom);
        }
        var offsetTop = dom.offsetTop;
        return offsetTop >= $(window).scrollTop() && offsetTop < ($(window).scrollTop() + $(window).height());
    },
    isShow: function (el) {
        var box;
        if(el instanceof  HTMLElement){
            box = el;
        }else {
            box = $(el);
        }
        console.log(box);
        var rect = box.getBoundingClientRect();
        console.log(rect);
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            );
    },
    parseURL: function(_url) {
        let url = decodeURIComponent(_url);
        let paramStr = url.split('?')[1];
        if (!paramStr) {
            return {};
        }
        let args = {};
        let items = paramStr.split('&');

        let item = null, name = null, value = null;
        for (let i = 0; i < items.length; i++) {
            item = items[i].split("=");
            if (item[0]) {
                name = item[0];
                value = item[1] ? item[1] : "";
                args[name] = value;
            }
        }
        return args;
    },
    isTestEnvironment:function () {
        if(window.location.host === 'm.sohu.com' || window.location.host === 't3.m.sohu.com') {
            return false;
        }else {
            return true;
        }
    },
    debounce:function (func, wait, options) {
        var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? Math.max(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
            var args = lastArgs,
            thisArg = lastThis;

            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }

        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

            return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
        }

        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
                (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
        }

        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
                return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
                return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
        }

        function cancel() {
            if (timerId !== undefined) {
                clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }

        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }

        function debounced() {
            var time = now(),
            isInvoking = shouldInvoke(time);

            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
                if (timerId === undefined) {
                    return leadingEdge(lastCallTime);
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) {
                timerId = setTimeout(timerExpired, wait);
            }
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    },
    throttle:function (func, wait, options) {
        var leading = true,
        trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return Util.debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
        });
    }

};
export default Util;


// WEBPACK FOOTER //
// ./src/_utils/util.js